import { Box } from "@mui/material";
import ic_price from "assets/icons/map_menu/ic_price.svg";
import ic_size from "assets/icons/map_menu/ic_size.svg";
import React, { useCallback } from "react";
import styles from "../EstateFilterDialog.module.scss";

export const EstateLabelButtons = React.memo(
  (props: {
    priceLabel: boolean;
    tsuboLabel: boolean;
    onPriceLabelChange: (value: boolean) => void;
    onTsuboLabelChange: (value: boolean) => void;
  }) => {
    const onPriceLabelClick = useCallback(() => {
      props.onPriceLabelChange(!props.priceLabel);
    }, [props]);

    const onTsuboLabelClick = useCallback(() => {
      props.onTsuboLabelChange(!props.tsuboLabel);
    }, [props]);

    return (
      <>
        <Box
          className={`${styles.btn_switch01} ${styles.btn_square} ${
            styles.click_act01
          } ${props.priceLabel === true ? styles.on : styles.off}`}
          onClick={onPriceLabelClick}
        >
          <Box component="img" src={ic_price} alt="価格ラベル" />{" "}
          <Box component="span">価格ラベル</Box>
        </Box>
        <Box
          className={`${styles.btn_switch01} ${styles.btn_square} ${
            styles.click_act01
          } ${props.tsuboLabel === true ? styles.on : styles.off}`}
          onClick={onTsuboLabelClick}
        >
          <Box component="img" src={ic_size} alt="坪ラベル" />{" "}
          <Box component="span">坪ラベル</Box>
        </Box>
      </>
    );
  }
);
